import {
  buildCreditReport,
  buildCreditReportForCurrentMonth,
  buildCreditReportForReportId,
  build1BCreditReportForCurrentMonth,
  build3BCreditReportForCurrentMonth,
  build3BCreditReportForReportId,
  build1BCreditReportForReportId,
  buildCreditReportDiscrepancies,
  buildUpdateDiscrepancy,
} from 'api-urls';
import {
  buildFetchOptionsWithHeaders,
  standardizedFetchHandler,
} from './service_helpers';

export async function fetchCreditReport() {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(buildCreditReport(), requestOptions);
}

export async function fetchCurrentCreditReport() {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    buildCreditReportForCurrentMonth(),
    requestOptions,
  );
}

export async function fetchCurrent1BCreditReport() {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    build1BCreditReportForCurrentMonth(),
    requestOptions,
  );
}

export async function fetchCreditReportById(reportId) {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    buildCreditReportForReportId(reportId),
    requestOptions,
  );
}

export async function fetchCurrent3BCreditReport() {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    build3BCreditReportForCurrentMonth(),
    requestOptions,
  );
}

export async function fetch3BCreditReportById(reportId) {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    build3BCreditReportForReportId(reportId),
    requestOptions,
  );
}

export async function fetch1BCreditReportById(reportId) {
  const requestOptions = buildFetchOptionsWithHeaders();

  return standardizedFetchHandler(
    build1BCreditReportForReportId(reportId),
    requestOptions,
  );
}

export async function fetchCreditReportDiscrepancies(reportId, body) {
  const requestOptions = buildFetchOptionsWithHeaders({
    method: 'POST',
    body,
  });

  return standardizedFetchHandler(
    buildCreditReportDiscrepancies(reportId),
    requestOptions,
  );
}

export async function fetchUpdateDiscrepancy(body) {
  const requestOptions = buildFetchOptionsWithHeaders({
    method: 'PUT',
    body,
  });

  return standardizedFetchHandler(buildUpdateDiscrepancy(), requestOptions);
}
